import { createReducer } from "@reduxjs/toolkit";
import { IItem } from "Model/Storage/IItem";
import { projectsStagingUpdateSuccess, uiStagingOpenSet } from "Store/Actions";
import { isEmpty } from "Utils/Object";

export const StagingValues = createReducer<IItem>({} as IItem, {
  [projectsStagingUpdateSuccess.type]: (_, { payload }) => {
    if (isEmpty(payload)) {
      return {};
    }

    return payload;
  },
  [uiStagingOpenSet.type]: (state, { payload: isOpen }) => (isOpen === false ? {} : state)
});
